import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';

export default function AttendanceChartBySundaySlots({ sundays, onDateClick }) {
  const [chartData, setChartData] = useState({ options: {}, series: [] });

  useEffect(() => {
    if (!sundays || !sundays.length) return;

    const sortedSundays = [...sundays].sort((a, b) => new Date(a.date) - new Date(b.date));
    const categories = sortedSundays.map((d) => dayjs(d.date).format('DD-MM-YYYY'));

    const slots = [7, 11, 15];
    const series = slots.map((slot) => ({
      name: `${slot}h`,
      data: sortedSundays.map((d) => {
        const s = d.slots.find((sl) => sl.slot === slot);
        return s ? s.count : 0;
      })
    }));

    const options = {
      chart: {
        type: 'area',
        stacked: true,
        events: {
          click: (event, chartContext, config) => {
            const index = config.dataPointIndex;
            const clickedDate = sortedSundays[index].date;
            onDateClick && onDateClick(clickedDate);
          }
        },
        zoom: {
          enabled: false
        },
        toolbar: {
          show: false
        }
      },
      xaxis: { categories },
      yaxis: { title: { text: 'Présences' } },
      tooltip: { shared: true, intersect: false }
    };

    setChartData({ series, options });
  }, [sundays, onDateClick]);

  return (
    <ReactApexChart
      series={chartData.series}
      options={chartData.options}
      type='area'
      height={400}
    />
  );
}
